import QueryState from "./components/QueryState";
import { useAuth } from "./lib/auth";
import Shell from "./routes/Shell";
import SignIn from "./routes/SignIn";

export default function App() {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <main className="flex min-h-full items-center justify-center p-6">
        <QueryState isPending isError={false} errorMessage={null} />
      </main>
    );
  }

  return session === null ? <SignIn /> : <Shell />;
}
